<template>

    <LoopItemPanel title="Item">

        <div class="shop::canvas-blocks-shop-contentImageTiles-BlockPanel">

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
    },

    data() {
        return {};
    },

}
</script>

<style lang="scss" scoped>

.shop\:\:canvas-blocks-shop-contentImageTiles-BlockPanel {

}

</style>
